import { defineStore } from 'pinia';

const tokenKey = 'moe_www_token';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem(tokenKey) || '',
  }),
  actions: {
    setToken(token: string) {
      this.token = token;
      localStorage.setItem(tokenKey, token);
    },
    clearToken() {
      this.token = '';
      localStorage.removeItem(tokenKey);
    },
  },
});
